var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.checkListLocal),function(itemCh,i){return _c('checklist-wrap-item',{key:i,staticClass:"mt12",attrs:{"isDetailTask":_vm.isDetailTask,"value":itemCh},on:{"change":_vm.changeChecklist}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }